// src/utils/branchPricing.ts
// Precio ESCALONADO de sucursales (plan único PRO, 2026-06-25).
// La 1ª sucursal va incluida en el precio del plan; entre más sucursales, más barata sale cada una.
//   sucursales 1-3 → $2,500/año c/u   ·   4-6 → $2,000   ·   7+ → $1,500
// El alta de sucursales se atiende MANUALMENTE (admin fija maxBranches); este helper es la
// fuente única de verdad para el calculador del admin y para el copy de ejemplos.

/** Precio anual de la k-ésima sucursal (k=1 es la 1ª, incluida en el plan). */
export function branchPriceAt(k: number): number {
  if (k <= 3) return 2500;
  if (k <= 6) return 2000;
  return 1500;
}

/** Costo total al año para N sucursales (incluye la 1ª = precio del plan). */
export function branchTotalPrice(n: number): number {
  let total = 0;
  for (let k = 1; k <= n; k++) total += branchPriceAt(k);
  return total;
}

/** Desglose por tramo para mostrar (ej. "3 × $2,500 + 2 × $2,000"). */
export function branchBreakdown(n: number): { count: number; price: number }[] {
  const tiers = [
    { upTo: 3, price: 2500 },
    { upTo: 6, price: 2000 },
    { upTo: Infinity, price: 1500 },
  ];
  const out: { count: number; price: number }[] = [];
  let prev = 0;
  for (const t of tiers) {
    const top = Math.min(n, t.upTo);
    const count = Math.max(0, top - prev);
    if (count > 0) out.push({ count, price: t.price });
    prev = top;
    if (prev >= n) break;
  }
  return out;
}
